export default __webpack_public_path__ + "static/media/typing-indicator.9896d74a.svg";